<template>
    <div>
        <div class="card card-xxl-stretch card-bordered">
            <div class="card-header">
                <div class="card-title">
                    {{ $t('transfer_parameters') }}
                </div>
            </div>
            <div class="card-body">
                <div class="d-flex flex-stack flex-wrap mb-5">
                    <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                        <button v-if="this.bankAccount !== 1" type="button" class="btn btn-sm btn-light btn-active-success me-3" ref="btnAddItem" @click="this.openTransferParameterModal('add')" data-bs-toggle="modal" data-bs-target="#kt_transfer_parameter_modal">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                        transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                    <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                        fill="currentColor">
                                    </rect>
                                </svg>
                            </span>
                            {{ $t('add_new') }}
                        </button>
                        <button type="button" class="btn btn-sm btn-light btn-active-primary me-3" @click="this.openTransferParameterModal('edit')" data-bs-toggle="modal" data-bs-target="#kt_transfer_parameter_modal"
                            :disabled="isTransferParameterButtonDisabled == null || isTransferParameterButtonDisabled == undefined">
                            <span class="svg-icon svg-icon-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                                        <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                                    </svg>
                            </span>
                            {{ $t('edit') }}
                        </button>
                        <button type="button" class="btn btn-sm btn-light btn-active-warning me-3" @click="this.deleteTransferParameterItem()" 
                            :disabled="isTransferParameterButtonDisabled == null || isTransferParameterButtonDisabled == undefined">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('remove') }}
                        </button>
                        <button type="button" class="btn btn-sm btn btn-light btn-active-danger me-3" @click="this.deleteTransferParameterItem(true)" 
                            :disabled="this.accountTransferParameters.length == 0">
                            <span class="svg-icon svg-icon-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('remove_all') }}
                        </button>
                    </div>
                </div>
                <div id="kt_datatable_example_1_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive">
                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                key-expr="id" 
                                :data-source="accountTransferParameters" 
                                :allow-column-reordering="true"  
                                :allow-column-resizing="true" 
                                :column-auto-width="true" 
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true" 
                                @exporting="this.$onExporting($event , 'Account-factor-list')">

                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="pageSize"/>
                                <DxPager :visible="true" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>    
                                <DxSearchPanel :visible="true"/>

                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />
                                <DxColumn data-field="isSelected" caption="#" :width="100" :allow-filtering="false" alignment="center" cell-template="is-selected-cell-template" :allow-exporting="false"/>
                                <DxColumn data-field="bank_account_name" :caption="this.bankAccount == 1 ? $t('account_name') : $t('bank_name')" alignment="left" />
                                <DxColumn data-field="transaction_type" :caption="$t('transaction_type')" alignment="left" />
                                <DxColumn data-field="transaction_in_out" :caption="$t('inout')" alignment="left" />
                                <DxColumn data-field="description_parameter_name" :caption="$t('description_parameter')" alignment="left" />
                                <DxColumn data-field="transaction_description" :caption="$t('description')" alignment="left"/>
                                <DxColumn data-field="created_by" :caption="$t('created_by')" alignment="left" />
                                
                                <template #is-selected-cell-template="{ data }"> 
                                    <span>
                                        <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center">
                                            <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" @change="this.onSelectTransferParameterItem(data.data)" />
                                        </div>
                                    </span>
                                </template>
                        </DxDataGrid>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="modal fade" id="kt_transfer_parameter_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content"  >
                    <div class="modal-header bg-primary">
                        <h2 class="modal-title fw-bolder col-md-10 text-white" v-if="modalType == 'add'">{{ $t('add_new_parameter') }}</h2>
                        <h2 class="modal-title fw-bolder col-md-10 text-white" v-if="modalType == 'edit'">{{ $t('edit_parameter') }}</h2>
                        <div class="btn btn-icon btn-sm btn-active-icon-primary"
                            data-bs-dismiss="modal" aria-label="Close" ref="closeAddAccountTransferParameterModal">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="card">
                            <div class="card-body py-3">                                
                                <div id="kt_policy_tab_1" class="tab-pane fade show active" role="tabpanel">
                                    <div class="fv-row row mb-7">
                                        <div class="col-lg-12" v-if="this.bankAccount !== 1">
                                            <label class="fs-6 fw-bold form-label mt-3 required">{{ $t('bank_account') }}</label>
                                            <Select2 :disabled="this.bankAccount == 1 && this.modalType == 'edit'" v-model="modalForm.bank_account_id" :options="bankAccountList" :settings="{ width: '100%', dropdownParent: '#kt_transfer_parameter_modal .modal-content'}"/>
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3 required">{{ $t('transaction_type') }}</label>
                                            <input type="text" class="form-control" name="transaction_type" v-model="modalForm.transaction_type">
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="fs-6 fw-bold form-label mt-3 required">{{ $t('inout') }}</label>
                                            <input type="text" class="form-control" name="transaction_in_out" v-model="modalForm.transaction_in_out">
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3">{{ $t('description_parameter') }}</label>
                                            <Select2 v-model="modalForm.description_parameter" :options="descriptionParameterList" :settings="{ width: '100%', dropdownParent: '#kt_transfer_parameter_modal .modal-content'}"/>
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="fs-6 fw-bold form-label mt-3 required">{{ $t('description') }}</label>
                                            <textarea rows="3" class="form-control" name="transaction_description" v-model="modalForm.transaction_description"></textarea>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer row mx-0">
                        <div class="d-grid gap-2">
                            <div class="btn-group"> 
                                <div class="col-lg-12">
                                    <div class="d-grid gap-2">
                                        <button type="button" class="btn btn-success btn-lg" v-if=" modalType == 'add'"
                                            @click="saveData()">
                                            <span class="indicator-label">{{ $t('save') }}</span> 
                                        </button>
                                        <button type="button" class="btn btn-primary btn-lg" v-if="modalType == 'edit'"
                                            @click="updateData()">
                                            <span class="indicator-label">{{ $t('update') }}</span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxPaging, DxPager, DxColumn, DxScrolling } from 'devextreme-vue/data-grid';
export default {
    name: 'AccountTransferParameters',
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxPaging, DxPager, DxColumn, DxScrolling
    },
    props:{
        bankAccount : String
    },
    data() {
        return {
            pageSize: 20,
            accountTransferParameters: [],
            bankAccountList: [],
            parentAccountId: this.$parent.form.id,
            bankList:[],
            modalForm: {
                id: null,
                transaction_type: null,
                transaction_in_out: null,
                transaction_description: null,
                description_parameter: 0,
                bank_account_id: '-1'
            },
            modalType: 'add',
            descriptionParameterList: [
                { id: 0, text: this.$t('equal_to')},
                { id: 1, text: this.$t('starts_with')},
                { id: 2, text: this.$t('ends_with')},
                { id: 3, text: this.$t('contains')}
            ]
        }
    },
    computed:{
        isTransferParameterButtonDisabled() {
            return this.accountTransferParameters.find(item => item.isSelected == true ); 
        },
        showPageSizeSelector() {
            return this.accountTransferParameters.length > this.pageSize;
        },
        pageSizes() {
            let arr = [];
            let x = 1;
            let loop = this.accountTransferParameters.length / this.pageSize;
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(this.pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        }
    },
    methods: {        
        openTransferParameterModal(modalType) {
            this.clearTransferParameterForm();
            this.modalType = modalType;
            if(modalType == 'edit') {
                this.accountTransferParameters.forEach(element => {
                    if(element.isSelected) {
                        this.modalForm.id = element.id;
                        this.modalForm.transaction_type = element.transaction_type;
                        this.modalForm.transaction_in_out = element.transaction_in_out;
                        this.modalForm.transaction_description = element.transaction_description;
                        this.modalForm.description_parameter = element.description_parameter;
                        this.modalForm.bank_account_id = element.bank_account_id;
                    }
                });
            }
        },
        getData() {
            const parameters = {
                session_id: this.$getUser().session_id,
                parent_account_id : this.parentAccountId,
                is_main_account: this.bankAccount == 1 ? 1 : 0, 
            };
            const parametersTwo = {
                session_id : this.$getUser().session_id,
                icl: 1,
                account_type : this.bankAccount == 1 ? -4 : 4, // Bank: 4
            };  
            
            const requestOne =  axios.post('/api/CompanyAccounts/GetTransferParameters', parameters, {'Content-Type': 'application/json'});
            const requestTwo =  axios.post('/api/CompanyAccounts/GetAccounts', parametersTwo, {'Content-Type': 'application/json'}); 
            
            axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                this.accountTransferParameters = responses[0].data;
                this.bankAccountList = responses[1].data.account_data;      
                this.bankAccountList.forEach(element => {
                    element.name = this.$unlock(element.name);
                    element.account_id = this.$unlock(element.account_id);
                    element.text = this.$unlock(element.text);
                });
                this.bankAccountList.unshift({id : '-1' , text : this.$t('select_an_option')});  
            }))
            .catch(errors => { 
                console.error(errors); 
            });
        },
        onSelectTransferParameterItem(item) {
            this.accountTransferParameters.forEach((value) => { 
                if (item.id !== value.id) {
                    value.isSelected = false;
                }
            });
        },
        deleteTransferParameterItem(isDeleteAll){
            let detailId = null;
            this.accountTransferParameters.forEach((item) => {
                if (item.isSelected) {
                    detailId = item.id;
                }
            });
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_remove_this_item'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('delete'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const parameters = {
                        session_id: this.$getUser().session_id,
                        parent_account_id: this.parentAccountId,
                        is_delete_all: isDeleteAll ? 1 : 0,
                        id: detailId,
                        is_main_account : this.bankAccount == 1 ? 1 :0,
                    }; 
                    axios.post('/api/CompanyAccounts/DeleteTransferParameter', parameters, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == '' || response.data.error == undefined){
                            this.getData();
                        } 
                    }) 
                    .catch((error) => {
                        console.error(error);
                        this.Progress.finish();
                    });
                }
            });
        },
        saveData() {
            const params = {
                session_id: this.$getUser().session_id,
                parent_account_id: this.parentAccountId,
                transaction_type: this.modalForm.transaction_type,
                transaction_in_out: this.modalForm.transaction_in_out,
                transaction_description: this.modalForm.transaction_description,
                description_parameter: this.modalForm.description_parameter,
                bank_account_id: this.modalForm.bank_account_id == '-1' ? null : this.modalForm.bank_account_id,
                is_main_account : this.bankAccount == 1 ? 1 : 0,
            };
            axios.post('api/CompanyAccounts/CreateTransferParameter',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
                    this.accountTransferParameters = response.data;
                    this.$refs.closeAddAccountTransferParameterModal.click();
                    this.clearTransferParameterForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        updateData() {
            const params = {
                session_id : this.$getUser().session_id,
                id: this.modalForm.id,
                transaction_type: this.modalForm.transaction_type,
                transaction_in_out: this.modalForm.transaction_in_out,
                transaction_description: this.modalForm.transaction_description,
                description_parameter: this.modalForm.description_parameter,
                bank_account_id: this.modalForm.bank_account_id == '-1' ? null : this.modalForm.bank_account_id,
                is_main_account : this.bankAccount == 1 ? 1: 0,
            };
            axios.post('api/CompanyAccounts/UpdateTransferParameter',params,{'Content-Type' : 'application/json'})
            .then((response) => {
                if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                    this.$swal(this.$t('success'), this.$t('data_update_succesfully'), 'success');  
                    this.accountTransferParameters = response.data;
                    this.$refs.closeAddAccountTransferParameterModal.click();
                    this.clearTransferParameterForm();
                }
            })
            .catch((error) => {
                console.error(error);
            });
            
        },
        clearTransferParameterForm() {
            this.modalForm = {
                id: null,                
                transaction_type: null,
                transaction_in_out: null,
                transaction_description: null,
                description_parameter: 0,
                bank_account_id: '-1'
            };
        }
    },
    created() {
        this.getData();
    }
}
</script>